<template>
  <div class="msg-page">
    <div class="container-fluid py-4 px-4">

      <nav aria-label="breadcrumb" class="mb-1">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
          <li class="breadcrumb-item active"><span class="breadcrumb-current">إدارة الرسائل</span></li>
        </ol>
      </nav>

      <div class="page-header mb-4">
        <div>
          <h1 class="page-header__title">
            <i class="pi pi-comments me-2" style="color:var(--gold)"></i>
            قوالب رسائل واتساب
          </h1>
          <p class="page-header__subtitle">اختر قالباً لتعديله أو لضبط حالة التفعيل</p>
        </div>
        <span v-if="!loading" class="templates-count-badge">
          <i class="pi pi-file-edit me-1"></i>
          {{ totalCount }} قالب
        </span>
      </div>

      <div v-if="loading" class="text-center py-5">
        <i class="pi pi-spin pi-spinner" style="font-size:2rem; color:var(--gold)"></i>
        <p class="text-muted mt-2">جاري تحميل القوالب...</p>
      </div>

      <div v-else>
        <div v-for="cat in CATEGORIES" :key="cat.id" class="mb-5">

          <div class="idx-cat-header mb-3">
            <div class="idx-cat-icon-wrap">
              <i class="pi" :class="cat.icon"></i>
            </div>
            <div>
              <h2 class="idx-cat-title">{{ cat.label }}</h2>
              <p class="idx-cat-desc">{{ cat.desc }}</p>
            </div>
          </div>

          <div class="row g-3">
            <div
              v-for="item in cat.items"
              :key="item.slug"
              class="col-xl-3 col-lg-4 col-md-6 col-12"
            >
              <div class="tpl-card">
                <div class="tpl-card__top">
                  <div class="tpl-card__icon">
                    <i class="pi" :class="item.icon"></i>
                  </div>
                  <span
                    class="status-badge"
                    :class="templateActive(item.code) ? 'status-badge--accepted' : 'status-badge--rejected'"
                  >
                    {{ templateActive(item.code) ? 'مفعّل' : 'معطّل' }}
                  </span>
                </div>
                <div class="tpl-card__body">
                  <h3 class="tpl-card__name">{{ templateName(item.code) || item.name }}</h3>
                  <p class="tpl-card__desc">{{ item.desc }}</p>
                </div>
                <div class="tpl-card__footer">
                  <!-- Original destination: `/messages/${item.slug}` -->
                  <router-link to="/coming-soon" class="btn-tpl-edit">
                    <i class="pi pi-pencil"></i>
                    تعديل
                  </router-link>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';

const CATEGORIES = [
  {
    id: 'individual',
    label: 'الرسائل الفردية',
    icon: 'pi-user',
    desc: 'تُرسل تلقائياً لكل طالب على حدة عند وقوع الحدث',
    items: [
      { slug: 'payment-confirmation',    code: 'payment_confirmation',    name: 'تأكيد السداد',   icon: 'pi-check-circle',   desc: 'تُرسل لولي الأمر فور تسجيل دفع الطالب' },
      { slug: 'absence',                 code: 'absence_notification',    name: 'تنبيه غياب',     icon: 'pi-calendar-times', desc: 'تُرسل لولي الأمر عند تسجيل غياب الطالب عن الحصة' },
      { slug: 'reservation',             code: 'reservation_notification',name: 'رسالة الحجز',   icon: 'pi-bookmark',       desc: 'تُرسل لولي الأمر عند تسجيل حجز جديد للطالب' },
      { slug: 'attendance-confirmation', code: 'attendance_confirmation', name: 'تأكيد الحضور',  icon: 'pi-check',          desc: 'تُرسل لولي الأمر عند تسجيل حضور الطالب بنجاح' },
    ],
  },
  {
    id: 'bulk',
    label: 'الرسائل الجماعية',
    icon: 'pi-send',
    desc: 'تُرسل دفعة واحدة لمجموعة من أولياء الأمور في آنٍ واحد',
    items: [
      { slug: 'payment-reminder',        code: 'payment_reminder_bulk',     name: 'تذكير جماعي بالسداد', icon: 'pi-bell',   desc: 'تُرسل لجميع غير المسددين دفعةً واحدة من صفحة المدفوعات' },
      { slug: 'absence-bulk',            code: 'absence_notification_bulk', name: 'إشعار غياب جماعي',   icon: 'pi-users',  desc: 'تُرسل لأولياء أمور الغائبين دفعةً واحدة من صفحة الحضور' },
    ],
  },
];

export default {
  name: 'MessagesIndex',
  data() {
    return {
      loading: true,
      templates: [],
      CATEGORIES,
    };
  },
  computed: {
    totalCount() {
      return CATEGORIES.reduce((sum, c) => sum + c.items.length, 0);
    },
  },
  methods: {
    templateActive(code) {
      const t = this.templates.find(t => t.code === code);
      return t ? t.is_active : true;
    },
    templateName(code) {
      const t = this.templates.find(t => t.code === code);
      return t?.name ?? '';
    },
    async loadTemplates() {
      this.loading = true;
      try {
        const res = await axios.get('/whatsapp-templates');
        this.templates = res.data.data ?? [];
      } catch { /* non-fatal */ } finally {
        this.loading = false;
      }
    },
  },
  mounted() { this.loadTemplates(); },
};
</script>

<style>
@import './messages.css';

.templates-count-badge {
  font-size: 0.8125rem;
  font-weight: 700;
  color: var(--gold);
  background: var(--gold-light);
  border: 1px solid rgba(247, 180, 36, 0.3);
  border-radius: var(--radius-full);
  padding: 0.35rem 0.875rem;
}

/* ── Category header ── */
.idx-cat-header {
  display: flex;
  align-items: center;
  gap: 0.875rem;
}

.idx-cat-icon-wrap {
  width: 38px;
  height: 38px;
  border-radius: var(--radius-md);
  background: var(--gold-light);
  border: 1px solid rgba(247, 180, 36, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.idx-cat-icon-wrap .pi {
  color: var(--gold);
  font-size: 1.05rem;
}

.idx-cat-title {
  font-size: 1rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 0.15rem;
  line-height: 1.2;
}

.idx-cat-desc {
  font-size: 0.76rem;
  color: var(--text-muted);
  margin: 0;
}

/* ── Template card ── */
.tpl-card {
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 1.125rem;
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  transition: box-shadow var(--ease-base), transform var(--ease-base), border-color var(--ease-base);
  height: 100%;
}

.tpl-card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
  border-color: rgba(247, 180, 36, 0.3);
}

.tpl-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tpl-card__icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  background: var(--gold-light);
  border: 1px solid rgba(247, 180, 36, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tpl-card__icon .pi {
  color: var(--gold);
  font-size: 1.1rem;
}

.tpl-card__body {
  flex: 1;
}

.tpl-card__name {
  font-size: 0.9rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 0.3rem;
  line-height: 1.3;
}

.tpl-card__desc {
  font-size: 0.76rem;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.55;
}

.tpl-card__footer {
  padding-top: 0.625rem;
  border-top: 1px solid var(--surface-border);
  display: flex;
  justify-content: flex-end;
}

.btn-tpl-edit {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.4rem 1rem;
  background: var(--gold);
  color: var(--btn-on-gold, #0F0F0F);
  border: none;
  border-radius: var(--radius-full);
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  transition: all var(--ease-base);
}

.btn-tpl-edit:hover {
  background: var(--gold-dark);
  transform: translateY(-1px);
  box-shadow: var(--shadow-primary);
  color: var(--btn-on-gold, #0F0F0F);
}
</style>
